const o=o=>{const{theme:t}=o;return{root:{flexFlow:"column nowrap",width:"auto",display:"flex",height:"100%",backgroundColor:t.semanticColors.disabledBackground},content:{flexGrow:1,zIndex:0},subComponentStyles:{topBarStyles:{}}}};export{o as getStyles};
//# sourceMappingURL=TopBarWrapper.styles.js.map
